import { render, staticRenderFns } from "./QuestionAnswerDetail.vue?vue&type=template&id=6ab36ff0&"
import script from "./QuestionAnswerDetail.vue?vue&type=script&lang=js&"
export * from "./QuestionAnswerDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAnswerDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports